<script setup lang="ts">
const route = useRoute('onderzoek-slug___nl')

const { data: chapters } = await useAsyncData(
  `investigation-${route.params.slug}-chapters`,
  () => queryCollection('investigationChapter')
    .where('path', 'LIKE', `%${route.params.slug}%`)
    .all(),
)

const isArticleSingle = computed(() => chapters.value?.length === 0)

const { data: article } = await useAsyncData(
  `investigation-${route.params.slug}`,
  () => queryCollection('investigation')
    .where('path', 'LIKE', `%${route.params.slug}%`)
    .first(),
)

useHead(article.value?.head || {})
useSeoMeta(article.value?.seo || {})

provide('article', article)

const title = computed<string>(() => article.value?.title ?? '')
</script>

<template>
  <ApplicationPage :title="title" :image="article?.image">
    <InvestigationArticleChapters v-if="!isArticleSingle && chapters" :chapters="chapters" />
    <InvestigationArticleSingle v-else />
    <InvestigationArticleSources v-if="article" class="relative z-10" />
  </ApplicationPage>
</template>
